import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface FloatingMenuProps {
  projectPage?: boolean;
}
const navigation = [{
  label: 'About',
  target: 'about'
}, {
  label: 'Our Projects',
  target: 'projects'
}, {
  label: 'Work With Us',
  target: 'working-with-us'
}];
export function FloatingMenu({
  projectPage = false
}: FloatingMenuProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const homeTarget = projectPage ? '/#top' : '#top';
  return <div className="sticky top-0 z-50 bg-[#01052a] shadow-md" data-id="element-30" data-mp="1nrjgj7lhtar5">
      <nav aria-label="Main navigation" className="w-full px-4 py-1" data-id="element-31" data-mp="1spuqrjfp9n9w">
        <div className="container mx-auto flex items-center justify-between" data-id="element-32" data-mp="1xgb4z5rchcxb">
          {projectPage ? <Link to={homeTarget} className="flex items-center rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Improbability Foundation home" data-id="element-33" data-mp="1016yh3wj9xmu">
              <div className="flex h-12 w-12 items-center justify-center" data-id="element-34" data-mp="1u8l6y7ebjruq">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cWkbjZCeq6nb6ZGzqApc86/image.png" alt="" className="h-9 w-9" data-id="element-35" data-mp="1q8172w2d2a4w" />
              </div>
            </Link> : <a href={homeTarget} className="flex items-center rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Improbability Foundation home" data-id="element-36" data-mp="1ggnd13t6i2j5">
              <div className="flex h-12 w-12 items-center justify-center" data-id="element-37" data-mp="12hx6kxkgyqi4">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cWkbjZCeq6nb6ZGzqApc86/image.png" alt="" className="h-9 w-9" data-id="element-38" data-mp="xjvmc9bb4l52" />
              </div>
            </a>}

          <div className="hidden items-center gap-10 md:flex" data-id="element-39" data-mp="2ry6asgnzpdab">
            {navigation.map(item => {
            const href = projectPage ? `/#${item.target}` : `#${item.target}`;
            const className = 'whitespace-nowrap text-sm font-light tracking-wide text-white transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
            return <a key={item.target} href={href} className={className} data-id="element-40" data-mp="3urahrm8wgdzl">
                  {item.label}
                </a>;
          })}
          </div>

          <button type="button" className="rounded-sm p-2 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white md:hidden" onClick={() => setMenuOpen(isOpen => !isOpen)} aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'} aria-expanded={menuOpen} aria-controls="mobile-navigation" data-id="element-41" data-mp="3ks1o6uhy51dr">
            {menuOpen ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-42" data-mp="26rf04g6u2640" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-43" data-mp="21u6jik1c2a4v" />}
          </button>
        </div>
      </nav>

      {menuOpen && <div id="mobile-navigation" className="border-t border-white/15 md:hidden" data-id="element-44" data-mp="2fsd8tbs7v1sx">
          <div className="container mx-auto flex flex-col py-2" data-id="element-45" data-mp="2aul75q1rs1bj">
            {navigation.map(item => {
          const href = projectPage ? `/#${item.target}` : `#${item.target}`;
          const className = 'px-6 py-3 text-sm font-light tracking-wide text-white transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-white/10 focus:outline-none focus-visible:bg-white/10';
          return <a key={item.target} href={href} className={className} onClick={() => setMenuOpen(false)} data-id="element-46" data-mp="14dzmibd42uf0">
                  {item.label}
                </a>;
        })}
          </div>
        </div>}
    </div>;
}